import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const project = {
  name: "Valiant",
  path: "/",
  redirect: "landing", // ubah ke "landing" jika ingin landing page sebagai default
  component: () => import("./module-layout.vue"),
  children: [
    {
      name: "Landing Page",
      path: "landing",
      component: () => import("./layouts/front-layout.vue"),
      children: [
        {
          path: "",
          meta: {
            reqLogout: true,
            isInternal: false
          },
          component: () => import("./pages/landing/index.vue"),
        },
      ],
    },
    {
      name: "Landing Internal Page",
      path: "landing-internal",
      component: () => import("./layouts/front-layout.vue"),
      children: [
        {
          path: "",
          meta: {
            reqLogout: true,
            isInternal: true
          },
          component: () => import("./pages/landing/index.vue"),
        },
      ],
    },
    {
      name: "Login SSO Page",
      path: "login",
      meta: {
        reqLogout: true,
      },
      component: () => import("./layouts/front-layout.vue"),
      children: [
        {
          path: "",
          name: 'LoginSSO',
          component: () => import("./pages/login/login-page.vue"),
        },
      ],
    },
    {
      name: "Login Page",
      path: "login-khusus-internal",
      meta: {
        reqLogout: true,
      },
      component: () => import("./layouts/front-layout.vue"),
      children: [
        {
          path: "",
          name: 'LoginKhususInternal',
          component: () => import("./pages/login/login-khusus-internal-page.vue"),
        },
      ],
    },
    {
      name: "Iam Login",
      path: "iam",
      component: () => import("./module-layout.vue"),
      children: [
        {
          path: "callback",
          meta: {
            reqLogout: true,
          },
          component: () => import('./pages/sso/sso-callback.vue')
        },
        {
          path: "logout",
          meta: {
            reqAuth: true,
          },
          component: () => import('./pages/sso/sso-logout.vue')
        }
      ],
    },
    {
      name: "Peta Views",
      path: "peta-views",
      meta: {
        reqAuth: true,
      },
      component: () => import("./layouts/front-layout.vue"),
      children: [
        {
          path: "",
          name: "PetaViews",
          component: () => import("./pages/data/peta-views.vue"),
        },
      ],
    },
    {
      name: "Beranda",
      path: "dashboard",
      redirect: "notfound",
      component: () => import("./layouts/internal-layout.vue"),
      meta: {
        reqAuth: true,
      },
      children: [
        {
          meta: {
            reqAuth: true,
            reqPermission: "view_lamanutama"
          },
          path: "laman-utama",
          component: () => import("./pages/dashboard/laman-utama.vue"),
        },
        {
          meta: {
            reqAuth: true,
            reqPermission: "view_lamandata"
          },
          path: "laman-data",
          component: () => import("./pages/dashboard/laman-data.vue"),
        },
        {
          meta: {
            reqAuth: true,
            reqPermission: "view_lamananalitik"
          },
          path: "laman-analitik",
          component: () => import("./pages/dashboard/laman-analitik.vue"),
        },
      ],
    },
    {
      name: "Data",
      path: "data",
      redirect: "notfound",
      component: () => import("./layouts/internal-layout.vue"),
      children: [
        {
          meta: {
            reqAuth: true,
            reqPermission: "view_simulation"
          },
          path: 'grafik-transmisi/:unitCode/:year',
          name: 'GrafikViewsTransmisi',
          component: () => import("./pages/data/grafik-views-transmisi.vue"),
        },
        {
          meta: {
            reqAuth: true,
            reqPermission: "view_simulation"
          },
          path: 'grafik-distribusi/:unitCode/:year',
          name: 'GrafikViewsDistribusi',
          component: () => import("./pages/data/grafik-views-distribusi.vue"),
        },
        {
          path: 'detail/:unitCode/:year',
          name: 'DetailViews',
          meta: {
            reqAuth: true,
            reqPermission: "view_simulation"
          },
          component: () => import('./pages/data/detail-views.vue')
        },
        {
          path: 'grafik-simulasi/:unitCode/:year',
          name: 'GrafikSimulasi',
          meta: {
            reqAuth: true,
            reqPermission: "add_simulation"
          },
          component: () => import('./pages/data/grafik-simulasi.vue')
        },
        {
          path: 'form-simulasi/:unitCode/:year',
          name: 'FormSimulasi',
          meta: {
            reqAuth: true,
            reqPermission: "add_simulation"
          },
          component: () => import('./pages/data/form-simulasi.vue')
        },
      ],
    },
    {
      name: "Verifikasi",
      path: "verifikasi",
      redirect: "notfound",
      component: () => import("./layouts/internal-layout.vue"),
      children: [
        {
          name: "persetujuan",
          path: "persetujuan",
          meta: {
            mode: 'APPROVAL',
            reqAuth: true,
            reqPermission: "view_simulation"
          },
          component: () => {
            const typeView = localStorage.getItem('typeView')?.toLowerCase()
            if (typeView === 'distribusi') {
              return import("./pages/data/grafik-views-distribusi.vue")
            }
            return import("./pages/data/grafik-views-transmisi.vue")
          },
        },
      ]

    },
    {
      name: "Master Page",
      path: "master",
      redirect: "notfound",
      component: () => import("./layouts/internal-layout.vue"),
      children: [
        {
          name: "userIndex",
          path: "user",
          meta: {
            reqAuth: true,
            reqPermission: "view_user"
          },
          component: () => import("./pages/master/master-user/master-user.vue"),
        },
        {
          path: "user/create",
          meta: {
            reqAuth: true,
            reqPermission: "add_user"
          },
          component: () => import("./pages/master/master-user/master-user-form.vue"),
        },
        {
          path: "user/edit/:id",
          meta: {
            reqAuth: true,
            reqPermission: "change_user"
          },
          component: () => import("./pages/master/master-user/master-user-form.vue"),
        },
        {
          name: "unitIndex",
          path: "unit",
          meta: {
            reqAuth: true,
            reqPermission: "view_unit"
          },
          component: () => import("./pages/master/master-unit/master-unit.vue"),
        },
        {
          path: "unit/create",
          meta: {
            reqAuth: true,
            reqPermission: "add_unit"
          },
          component: () => import("./pages/master/master-unit/master-unit-form.vue"),
        },
        {
          path: "unit/edit/:id",
          meta: {
            reqAuth: true,
            reqPermission: "change_unit"
          },
          component: () => import("./pages/master/master-unit/master-unit-form.vue"),
        },
        {
          name: 'roleIndex',
          path: "role",
          meta: {
            reqAuth: true,
            reqPermission: "view_group"
          },
          component: () => import("./pages/master/master-role/master-role.vue"),
        },
        {
          path: "role/create",
          meta: {
            reqAuth: true,
            reqPermission: "add_group"
          },
          component: () => import("./pages/master/master-role/master-role-form.vue"),
        },
        {
          path: "role/edit/:id",
          meta: {
            reqAuth: true,
            reqPermission: "change_group"
          },
          component: () => import("./pages/master/master-role/master-role-form.vue"),
        },
        {
          name: 'AsumsiIndex',
          path: "asumsi",
          meta: {
            reqAuth: true,
            reqPermission: "view_asumsi"
          },
          component: () => import("./pages/master/master-asumsi/master-asumsi.vue"),
        }
      ],
    },
    {
      name: "Log Aktifitas",
      path :"log",
      redirect : "notfound",
      component : ()=> import("./layouts/internal-layout.vue"),
      children :[
     {
          name: "logIndex",
          path: "activities",
          meta: {
            reqAuth: true,
            reqPermission: "view_user"
          },
          component: () => import("./pages/log/log-activities.vue"),
        },
      ]
    },
    {
      name: "404",
      path: "notfound",
      component: () => import("./pages/other/notfound-page.vue"),
    },
    {
      name: "401",
      path: "401",
      component: () => import("./pages/other/unauthorized-page.vue"),
    },
  ],
};

export default project
